module.exports = __webpack_public_path__ + "img/icon_down.5a5dcc86.svg";